import { IGetData } from '../get-data';

export class EmptyMock implements IGetData {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    getData(reqInfo: RequestInfo, db?: any): unknown {
        return {} as unknown;
    }
}
